/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState} from "react";
import AppContainer from "../../../Components/Structure/AppContainer";
import { Link } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Loader from "../../../Components/Common/Loader";
import useStateCallback from "../../../util/customHooks/useStateCallback";
import { RenderSecure } from "../../../util/script/RenderSecure";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import StationContext from "../../../Context/StationContext";
import UpdateStation from "../../../Components/CallingStation/UpdateStation";
import TurnOnStation from "../../../Components/CallingStation/TurnOnStation";
import TurnOffStation from "../../../Components/CallingStation/TurnOffStation";
import AddStation from "../../../Components/CallingStation/AddStation";
import AddWorkingHours from "../../../Components/CallingStation/AddWorkingHours";
import UpdateTimeRangeHours from "../../../Components/CallingStation/UpdateTimeRangeHours";
import SearchForm from "../../../Components/Common/SearchForm";
import UninstallStation from "../../../Components/CallingStation/Uninstall Station";
import RestartBooth from "../../../Components/CallingStation/RestartBooth";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import SMSUpdate from "../../../Components/CallingStation/SMSUpdate";
function CallStationsPage() {
  const [modal, setModal] = useStateCallback(false);
  const {groupedStationList, page, query, searchQuery, loading3, loading4, loading5, setQuery, setSearchQuery, setPage, stationTimeRanges, getGroupedStations,
    searchGroupedStations, stationNumber, activeStationNumber,inactiveStationNumber, offStationNumber} = useContext(StationContext);

  const [loadingPage, setLoadingPage] = useState(true);

  // useEffect(() => {
  //   if (query) {
  //     searchGroupedStations();
  //   } else {
  //     getGroupedStations();
  //   }
  // }, []);

   useEffect(() => {
    const fetchAll = async () => {
      setLoadingPage(true);
      await Promise.all([
        query ? searchGroupedStations() : getGroupedStations(),
      ]);
      setLoadingPage(false);
    };
  
    fetchAll();
  }, []);

  const setStations = (e) => {
    e.preventDefault();
    setQuery("");
    setPage(1);
    getGroupedStations();
  };

  const updateStation = (e, item) => {
    setModal(false, () => setModal(<UpdateStation stationID={item.station_id} stationName={item.station_name} schoolName={item.school.school_id} g={getGroupedStations} isOpen={true}/>));
  };

  const addHours = (e, item) => {
    setModal(false, () => setModal(<AddWorkingHours stationID={item.station_id} g={getGroupedStations} page={page} isOpen={true}/>));
  };

  const handleUpdateHours = (e, timeRange) => {
    setModal(false, () => setModal(<UpdateTimeRangeHours timeID={timeRange.time_id} g={getGroupedStations} page={page} startTime={timeRange.start_time} endTime={timeRange.end_time} startDay={timeRange.start_day} endDay={timeRange.end_day} isOpen={true}/>));
  };

  const stationOn = (e, item) => {
    setModal(false, () => setModal(<TurnOnStation stationID={item.station_id} g={getGroupedStations} page={page} isOpen={true}/>));
  };

  const stationOff = (e, item) => {
    setModal(false, () => setModal(<TurnOffStation stationID={item.station_id} g={getGroupedStations} page={page} isOpen={true}/>));
  };

  const stationAdd = (e, item) => {
    setModal(false, () => setModal(<AddStation g={getGroupedStations} isOpen={true}/>));
  };

  const uninstallStation = (e, item) => {
    setModal(false, () => setModal(<UninstallStation stationCode={item.station_code} g={getGroupedStations} isOpen={true}/>));
  };

  const restartStation = (e, item) => {
    setModal(false, () => setModal(<RestartBooth stationCode={item.station_code} g={getGroupedStations} page={page} isOpen={true}/>));
  };

  const restartStationWithSMS = (e, item) => {
    setModal(false, () => setModal(<SMSUpdate stationID={item.station_id} g={getGroupedStations} page={page} isOpen={true}/>));
  };

  const refreshData = () => {
    getGroupedStations();
  };

  return (
    <AppContainer title="Calling Stations">
      <Toaster position="top-center" reverseOrder={false} />
      {modal}
      {loadingPage ? (
                                // Full page skeleton loader
                                <div style={{ padding: 40 }}>
                                  <Skeleton height={40} width={300} style={{ marginBottom: 20 }} />
                                  <Skeleton height={200} style={{ marginBottom: 20 }} />
                                  <Skeleton count={5} height={30} style={{ marginBottom: 10 }} />
                                </div>
                              ) : (<>
      <div className="row">
        <div className="col-lg-12 col-md-12">
          <div className="pl-20" style={{ float: "right" }}>
            <Link onClick={stationAdd}>
              <button type="button" className="btn-fill-lmd radius-30 mb-5 text-light shadow-dodger-blue bg-dodger-blue">
                <i className="fa-solid fa-plus" /> Add New Station
              </button>
            </Link>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-lg-12">
              <div className="card custom-card" style={{paddingBottom:"10px"}}>
                <div className="card-body map-card gradient-my-blue">
                  <div className="item-title mb-2" style={{color:"white"}}><b>STATISTICS </b></div>
                  <div className="row">
                    <div className="col-xl-3 col-lg-12 col-sm-6 pr-0 pl-0 border-right">
                      <div className="text-center">
                        <h2 className="mb-1 number-font" style={{color:"white"}}><span className="counter">{stationNumber ? stationNumber.total_p : "..."}</span></h2>
                        <p className="mb-0 text-light"> Total Stations</p>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-12 col-sm-6 pr-0 pl-0 border-right">
                      <div className="text-center">
                        <h2 className="mb-1 number-font" style={{color:"white"}}><span className="counter">{activeStationNumber ? activeStationNumber.total_p : "..."}</span></h2>
                        <p className="mb-0 text-light"> Active Stations</p>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-12 col-sm-6 pr-0 pl-0 border-right">
                      <div className="text-center">
                        <h2 className="mb-1 number-font" style={{color:"white"}}><span className="counter">{inactiveStationNumber ? inactiveStationNumber.total_p : "..."}</span></h2>
                        <p className="mb-0 text-light"> Inactive Stations</p>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-12 col-sm-6 pr-0 pl-0">
                      <div className="text-center">
                        <h2 className="mb-1 number-font" style={{color:"white"}}><span className="counter">{offStationNumber ? offStationNumber.total_p : "..."}</span></h2>
                        <p className="mb-0 text-light"> Off Stations</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>                  
            </div>

            <div className="col-lg-12">
            <div className="card custom-card" >
              <div className="card-body map-card">
                <div class="heading-layout1 mg-b-5">
                  <div>
                                <h5 style={{ marginBottom: 0 }} className="card-title">
                                Call Stations / Booths
                                </h5>
                               

                                
                            </div>
                  <div class="dropdown">
                    <Link class="dropdown-toggle" role="button" data-toggle="dropdown" aria-expanded="false">
                      ...
                    </Link>

                    <div class="dropdown-menu dropdown-menu-right">
                      <Link class="dropdown-item" onClick={refreshData}>
                        <i class="fas fa-redo-alt text-orange-peel"></i>Refresh
                      </Link>
                      
                    </div>
                  </div>
                </div>

                <SearchForm searchTerm={searchQuery} setItems={setStations} searchItems={searchGroupedStations} setPage={setPage} setSearchTerm={setSearchQuery} placeholder="Enter station code, station name or name of school..."/>
               <div className="row">
               {Object.entries(groupedStationList).map(([schoolName, stations], index) => (
  <div className="col-lg-12 col-md-12 col-12 col-sm-12" key={index}>
    <div className="card custom-card mb-3">
      <div className="card-body">
        <h6>{schoolName !== "Not Installed" ? schoolName : "Unassigned Stations / Booths"}</h6>
        <div className="table-responsive">
        {loading3 || loading4 ? (
                    <Loader /> 
                  ) : (
          <table className="table display data-table text-nowrap">
            <thead>
              <tr>
                <th>#</th>
                <th>Station Name</th>
                <th>Working Hours</th>
                <th>Status</th>
                <th>Connectivity</th>
                <th>Recent Activity</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {stations.map((item, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>
                    {item.station_name} <small>(v{item.current_version?item.current_version:"0.0"})</small>
                    <br />
                    <small>{item.station_code}</small>
                    <br />
                    
                    {item.simcard_number === "Not Configured"? "":<small style={{color:"gray"}}>SIM Card No: {item.simcard_number}</small>}
                  </td>
                  <td>
                    {loading5? <Skeleton count={2} width={180} height={18} />:
                    stationTimeRanges[item.station_id]?.length > 0 ? (
                      <ul>
                        {stationTimeRanges[item.station_id].map((range, idr) => (
                          <li key={idr}>
                            {range.start_day} - {range.end_day} : {range.start_time} - {range.end_time}
                            <span
                              className="ml-2 text-secondary cursor-pointer"
                              onClick={(e) => handleUpdateHours(e, range)}
                            >
                              <i className="fa fa-pencil-alt"></i>
                            </span>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      "No working hours set"
                    )}
                  </td>
                  <td>
                    {item.status === "300" ? (
                      <span className="badge badge-success">Active</span>
                    ) : item.status === "500" ? (
                      <span className="badge badge-warning">Inactive</span>
                    ) : (
                      <span className="badge badge-danger">Off</span>
                    )}<br/>
                    
                  </td>
                  <td>{item.connectivity_status === "Online" ? (
                      <span className="badge badge-success">Connected</span>
                    ) : (
                      <span className="badge badge-danger">Not Connected</span>
                    )}</td>
                  <td>
                    {item.recent_activity?.source === "Call" ? (
                      <>
                        <span className="badge badge-info">
                          <i className="fa fa-phone"></i> Call
                        </span>
                        <br />
                        <small>{item.recent_activity.last_activity}</small>
                      </>
                    ) : item.recent_activity?.source === "Chat" ? (
                      <>
                        <span className="badge badge-info">
                          <i className="fa fa-message"></i> Chat
                        </span>
                        <br />
                        <small>{item.recent_activity.last_activity}</small>
                      </>
                    ) : (
                      "No recent activity"
                    )}
                  </td>
                  <td>
                                <div className="dropdown">
                                  <Link
                                    to="#"
                                    className="dropdown-toggle"
                                    data-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <span className="flaticon-more-button-of-three-dots"></span>
                                  </Link>
                                  <div className="dropdown-menu dropdown-menu-right">
                                    <Link
                                      className="dropdown-item"
                                      to="#"
                                      onClick={(e) => addHours(e, item)}
                                    >
                                      <FontAwesomeIcon
                                        icon={faClock}
                                        style={{
                                          color: "green",
                                          marginRight: "3px",
                                        }}
                                      />
                                      Add Station Hours
                                    </Link>
                                    <RenderSecure code="ADMIN-VIEW">
                                      <Link
                                        className="dropdown-item"
                                        to="#"
                                        onClick={(e) => updateStation(e, item)}
                                      >
                                        <i
                                          className="far fa-edit mr-1"
                                          style={{ color: "orange" }}
                                        ></i>
                                        Update Station Details
                                      </Link>
                                      <Link
                                        className="dropdown-item"
                                        to="#"
                                        onClick={(e) => restartStation(e, item)}
                                      >
                                        <i
                                          className="fa fa-wifi mr-1"
                                          style={{ color: "gray" }}
                                        ></i>
                                        Restart Booth (Internet)
                                      </Link>
                                      {item.simcard_number === "Not Configured"?"":<Link
                                        className="dropdown-item"
                                        to="#"
                                        onClick={(e) => restartStationWithSMS(e, item)}
                                      >
                                        <i
                                          className="fa fa-envelope mr-1"
                                          style={{ color: "black" }}
                                        ></i>
                                        Restart Booth (SMS)
                                      </Link>}
                                    </RenderSecure>
                                    {item.status === "300" ? (
                                      <Link
                                        className="dropdown-item"
                                        to="#"
                                        onClick={(e) => stationOff(e, item)}
                                      >
                                        <i
                                          className="fa fa-power-off mr-1"
                                          style={{ color: "red" }}
                                        ></i>
                                        Turn Off
                                      </Link>
                                    ) : (
                                      <Link
                                        className="dropdown-item"
                                        to="#"
                                        onClick={(e) => stationOn(e, item)}
                                      >
                                        <i
                                          className="fa fa-power-off mr-1"
                                          style={{ color: "green" }}
                                        ></i>
                                        Turn On
                                      </Link>
                                    )}
                                    <RenderSecure code="ADMIN-VIEW">{schoolName !== "Not Installed"?
                                      <Link
                                        className="dropdown-item"
                                        to="#"
                                        onClick={(e) => uninstallStation(e, item)}
                                      >
                                        <i
                                          className="fa fa-screwdriver-wrench mr-1"
                                          style={{ color: "black" }}
                                        ></i>
                                        Uninstall Station
                                      </Link>
                                    :""}</RenderSecure>
                                  </div>
                                </div>
                              </td>
                </tr>
              ))}
            </tbody>
          </table>)}
        </div>
      </div>
    </div>
  </div>
))}

              
              
              </div>

              </div>
            </div>
            </div>
          </div>
        </div>

        
      </div></>) }
    </AppContainer>
  );
}

export default CallStationsPage;
